export default "__VITE_ASSET__Zw4RCzte__"